// import React from 'react'

// const HomeBanner = () => {
//     return (
//         <>

//             <div className="carousel-header">
//                 <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
//                     <div className="carousel-inner" role="listbox">
//                         <div className="carousel-item active">
//                             <img src="./assets/img/Top Taxi Service in Satna.png" className="img-fluid" alt="Image" />
//                             <div className="carousel-caption">
//                                 <div className="text-center p-4" style={{ maxWidth: 900, color:"red" }}>
//                                     <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.5s" style={{color:"red"}}>In Satna, we at Shiv Travels Taxi Services provide dependable and reasonably priced cabs. Our goal has always been to offer comfortable and safe transportation. We can assist you whether you need a transportation for a round-trip or one-way travel, local hourly use, or an airport transfer.</p>
//                                     <a className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">+91-7389578180</a>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </div>


//         </>
//     )
// }

// export default HomeBanner



import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';


import { Autoplay } from 'swiper/modules';

export default function HomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}


                modules={[Autoplay]}
                className="mySwiper"
                style={{ overflow: "hidden" }}
            >

                <SwiperSlide>
                    <div className="carousel-item active">
                        <img src="./assets/img/Top Taxi Service in Satna.webp" className="img-fluid" alt="Image" />
                        {/* <div className="carousel-caption">
                            <div className="text-center p-4" style={{ maxWidth: 900, color: "red" }}>
                                <p className="text-white mb-4 mb-md-5 fs-5 wow fadeInUp" data-wow-delay="0.5s" style={{ color: "red" }}>In Satna, we at Shiv Travels Taxi Services provide dependable and reasonably priced cabs. Our goal has always been to offer comfortable and safe transportation. We can assist you whether you need a transportation for a round-trip or one-way travel, local hourly use, or an airport transfer.</p>
                                <a className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">+91-7389578180</a>
                            </div>
                        </div> */}
                    </div>
                </SwiperSlide>


            </Swiper>
        </>
    );
}
